export default __webpack_public_path__ + "static/char-50-7ad05d9ca8d27fa47ce783b3622a6692.gif";